import { render } from "./ForbiddenView.vue?vue&type=template&id=b6138820&scoped=true"
const script = {}

import "./ForbiddenView.vue?vue&type=style&index=0&id=b6138820&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6138820"]])

export default __exports__